'use client';

import MyPointCard from '@/app/(football)/[team]/_components/common/MyPointCard';

export default function HeroSection() {
  return (
    <div className="flex w-full flex-col items-center px-5 pt-8 pb-9">
      <h1 className="text-center typo-heading-1 text-g-00">미니 게임</h1>
      <p className="pt-2 text-center typo-body-5 text-g-00">최고 기록을 향해 블록을 쌓고</p>
      <p className="pt-0.5 text-center typo-body-5 text-g-00">포인트도 쏙쏙 모아보세요</p>

      <div className="mt-6 w-full">
        <MyPointCard />
      </div>
    </div>
  );
}
